import React, { useState } from 'react';
import { useTranslate } from '@im/react-localization';
import SearchBarComp from 'src/components/SearchBar/SearchBar';
import { useDiscountLinesLookup } from 'src/views/vendorprogram/hooks/deal-details';
import debounce from '@mui/material/utils/debounce';

const DEBOUCE_DELAY = 500;

export default function DiscountLinesSearchBar(
  props: Readonly<{
    dealid: number;
    importreferenceid: number;
    onClear: () => void;
    onOptionSelected: (value: string) => void;
  }>
) {
  const translate = useTranslate();
  const [inputValue, setInputValue] = useState<string>('');
  const onInputChange = (value: string) => {
    setInputValue(value);
  };

  const { data } = useDiscountLinesLookup(props.importreferenceid, {
    dealid: props.dealid,
    page: 1,
    pageSize: 20,
    q: inputValue.trim(),
  });
  const options = data ?? [];

  const onOptionSelected = (value: string) => {
    props.onOptionSelected(value);
  };
  return (
    <SearchBarComp
      autoCompleteDataTestId="gds-searchResult-searchBar"
      exception={false}
      onClear={props.onClear}
      onInputChange={debounce(onInputChange, DEBOUCE_DELAY)}
      onOptionSelected={onOptionSelected}
      options={options.map((o) => o.vpn)}
      placeHolder={translate('VendorDeals.SearchDiscountLines')}
      textFieldDataTestId="gds-searchResult-searchBar"
    />
  );
}
